import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';

import { SESSION_SLICE_KEY } from './session.constants';
import {
  checkForExistingTokens,
  clearAccessToken,
  clearTokens,
  setTokens,
} from './session.thunks';
import { SessionSliceState } from './session.types';

const initialState: SessionSliceState = {
  isLoading: true,
  data: undefined,
};

const extraReducers = (builder: ActionReducerMapBuilder<SessionSliceState>) => {
  builder.addCase(
    checkForExistingTokens.fulfilled,
    (
      state,
      { payload }: { payload: SessionSliceState['data'] | undefined },
    ) => {
      state.isLoading = false;
      state.data = payload;
    },
  );
  builder.addCase(checkForExistingTokens.rejected, state => {
    state.isLoading = false;
    state.data = undefined;
  });
  builder.addCase(
    setTokens.fulfilled,
    (state, { payload }: { payload: SessionSliceState['data'] }) => {
      state.data = payload;
    },
  );
  builder.addCase(clearTokens.fulfilled, state => {
    // @ts-expect-error TODO: This stops storybook from resetting the userId, but want a better solution
    if (window.__STORYBOOK_PREVIEW__) return;
    state.data = initialState.data;
  });
  builder.addCase(clearAccessToken.fulfilled, state => {
    state.data = initialState.data;
  });
};

const sessionSlice = createSlice({
  name: SESSION_SLICE_KEY,
  initialState,
  reducers: {},
  extraReducers,
});

export const sessionActions = sessionSlice.actions;
export const { reducer: sessionReducer } = sessionSlice;
